import { render, staticRenderFns } from "./DescriptionComponent.vue?vue&type=template&id=fe1b5ba0&scoped=true"
import script from "./DescriptionComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionComponent.vue?vue&type=script&lang=js"
import style0 from "./DescriptionComponent.vue?vue&type=style&index=0&id=fe1b5ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1b5ba0",
  null
  
)

export default component.exports